module.exports = __webpack_public_path__ + "img/alert-circle.af9c8cf6.svg";